import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { TranslateService } from '../../shared/services/translate.service';
import { RegisterResult } from '../../core/models/register-result';

type RegistrationForm = FormGroup<{
  email: FormControl<NonNullable<string>>;
  password: FormControl<NonNullable<string>>;
  confirmPassword: FormControl<NonNullable<string>>;
  termsAccepted: FormControl<boolean>;
}>;

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
})
export class RegistrationComponent {
  form: RegistrationForm = new FormGroup({
    email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.minLength(10)] }),
    confirmPassword: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    termsAccepted: new FormControl(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
  });

  isSubmitting = false;
  errorMessage = '';
  registrationResult: RegisterResult | null = null;

  constructor(
    private auth: AuthService,
    private tSvc: TranslateService,
  ) {}

  t(key: string) {
    return this.tSvc.translate(key);
  }

  get email() {
    return this.form.controls.email;
  }

  get password() {
    return this.form.controls.password;
  }

  get confirmPassword() {
    return this.form.controls.confirmPassword;
  }

  get termsAccepted() {
    return this.form.controls.termsAccepted;
  }

  get passwordsDoNotMatch(): boolean {
    return !!this.password.value && !!this.confirmPassword.value && this.password.value !== this.confirmPassword.value;
  }

  onSubmit() {
    if (this.form.invalid || this.passwordsDoNotMatch) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.registrationResult = null;

    this.auth.register({
      email: this.email.value,
      password: this.password.value,
      termsAccepted: this.termsAccepted.value,
    }).subscribe({
      next: (result) => {
        this.registrationResult = result;
        this.isSubmitting = false;
        this.form.disable();
      },
      error: (error) => {
        console.log('Registration error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Registration failed. Please check your details and try again.';
        this.isSubmitting = false;
      },
    });
  }
}
